// IMPORTS:

// STYLES
import 'bootstrap/scss/bootstrap.scss'
import 'choices.js/public/assets/styles/choices.min.css'

// Main.scss should always be last, otherwise your styles can be overwrite by styles from libraries
import '../scss/main.scss'

// Popper - neccessary for bootstrap
import '@popperjs/core'

// Bootstrap
import 'bootstrap'

import autosize from 'autosize/dist/autosize.js'
autosize(document.querySelectorAll('textarea'))

import scrollSmooth from 'scroll-smooth'

// PLUGINS
import './plugins/PluginLoadDependecies.ts'
import './plugins/PluginOutline.ts'
import './plugins/PluginDeviceType.ts'
import './plugins/PluginRecaptcha.ts'
import './plugins/PluginSVGConverter.ts'
import './plugins/PluginBwMenu.ts'
import LazyLoad, { LazyMode } from './plugins/PluginLazyLoad.ts'
import LASingleLettersBreaker from './plugins/PluginSingleLetters.ts'
// import { CookiesController } from './plugins/PluginCookies.ts'
// import './plugins/PluginAnalytics.ts'
// import './plugins/PluginBlockEmbed.ts'
import './components/ComponentSmoothScroll.ts'

// Create CookiesController instance
// window.CookiesController = new CookiesController()

new LASingleLettersBreaker({ autoInit: true })

window.addEventListener('load', () => {
  new LazyLoad({
    rootMargin: '200px',
    root: null,
    threshold: 0,
    imageOptions: {
      classDefault: 'lazy-image',
      classOnLoad: 'lazy-image--active',
    },
    mode: LazyMode.EXCLUDE,
    url: '/api/image/',
    selectors: ['[data-item="svg"]', '[data-nolazy="true"]'],
  })
})

// Reinit lazy load on custom event

window.addEventListener('bw-lazy-reload', () => {
  new LazyLoad({
    rootMargin: '200px',
    root: null,
    threshold: 0,
    imageOptions: {
      classDefault: 'lazy-image',
      classOnLoad: 'lazy-image--active',
    },
    mode: LazyMode.EXCLUDE,
    url: '/api/image/',
    selectors: ['[data-item="svg"]', '[data-nolazy="true"]'],
  })
})

// COMPONENTS
import './components/ComponentAos.ts'
import './components/ComponentLightbox.ts'
import './components/ComponentSelect.ts'

import SimpleBar from 'simplebar';
import 'simplebar/dist/simplebar.css';

// Init custom scrollbar
window.addEventListener('load', () => {
  initCustomScroll();
})

// Handle reinit on custom event
document.body.addEventListener('bw-custom-scroll-reload', () => {
  initCustomScroll();
})

function initCustomScroll() {
  // Find all elements where custom scroll should be initialized
  const scrollsContainers = document.querySelectorAll(`[data-custom-scroll='init']`);
  if (scrollsContainers.length > 0) {
    scrollsContainers.forEach(container => {
      // Check if custom srcoll has ben alread init on this container
      if (container.getAttribute("data-custom-scroll-active") != "true") {
        container.setAttribute("data-custom-scroll-active", "true");

        new SimpleBar(container, { autoHide: false });
      }
    })
  }
}

// Remove preload class on load
window.addEventListener('load', () => {
  // hide loader
  window.setTimeout(() => {
    const loader = document.querySelector("[data-item='loader']")
    const loaderStyle = document.querySelector("[data-item='loader-styles']")

    if (loader && loader.parentNode) {
      loader.parentNode.removeChild(loader)
    }
    if (loaderStyle && loaderStyle.parentNode) {
      loaderStyle.parentNode.removeChild(loaderStyle)
    }
  }, 250)

  // Remove class that prevent transition
  const preload = document.querySelector('body')
  if (preload) {
    preload.classList.remove('preload')
  }

  const servicesSection = document.querySelector<HTMLElement>(`[data-slider="services"]`);

  if (servicesSection) {
    servicesSection.setAttribute('style', `--width-services: ${servicesSection.offsetWidth}px`)
  }


  const testYourPropertyBtn = document.querySelector(`[data-item="test-your-property"]`)

  if (testYourPropertyBtn) {
    const testYourPropertyWrapper = document.querySelector(`${testYourPropertyBtn.getAttribute('href')}`)

    testYourPropertyBtn.addEventListener('click', (e) => {
      e.preventDefault()

      if (testYourPropertyWrapper) {
        testYourPropertyBtn.classList.remove('animation')
        testYourPropertyBtn.blur();
        scrollSmooth.to(testYourPropertyWrapper, {
          duration: 800,
          offset: -100,
        })
      }
    })
  }

  // go to top

  const goTopBtn = document.querySelector(`[data-item="go-top"]`)

  if (goTopBtn) {

    goTopBtn.addEventListener('click', (e) => {
      e.preventDefault()

      window.scrollTo(0, 0)

    })
  }
})
